if (!customElements.get("m-collection-header")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const { MinimogThemeScripts: e } = window;
      if ("true" === this.dataset.enableParallax && window.innerWidth > 767) {
        const a = this.querySelector(".m-collection-page-header__bg");
        loadAssetsNew([e.parallax], "parallax-module-collection-header", () => {
          new MinimogLibs.simpleParallax(a, {
            delay: 1.8,
            transition: "cubic-bezier(0,0,0,1)",
            orientation: "down",
            scale: 1.5,
            customWrapper: ".m-collection-page-header",
          });
        });
      }
    }
  }
  customElements.define("m-collection-header", e);
}
